"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _APTable = _interopRequireDefault(require("../common/APTable"));
var _PaddedDecimal = _interopRequireDefault(require("../common/PaddedDecimal/PaddedDecimal"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _dateHelper = require("../../helpers/dateHelper");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _recentTradesSelectors = require("../../redux/selectors/recentTradesSelectors");
var _selectors = require("../../redux/futures/selectors");
require("./RecentTradesComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('recent-trades');
var RecentTradesComponent = function RecentTradesComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var selectedInstrument = props.selectedInstrument;
  var isFuturesActive = (0, _reactRedux.useSelector)(_selectors.isFuturesActiveSelector);
  var recentTrades = (0, _reactRedux.useSelector)(isFuturesActive ? _recentTradesSelectors.futuresRecentTradesSelector : _recentTradesSelectors.recentTradesSelector);
  var fetching = (0, _reactRedux.useSelector)(function (state) {
    return isFuturesActive ? state.futures.recentTrades.fetching : state.recentTrades.fetching;
  });
  var columns = [{
    header: t('Price'),
    cell: function cell(row) {
      var side;
      if (isFuturesActive) {
        side = row.Direction === 2 ? 'sell' : 'buy';
      } else {
        side = row.TakerSide === 0 ? 'buy' : 'sell';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-price', side)
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: row.Price,
        bemMod: side,
        decimals: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)
      }));
    }
  }, {
    header: t('Qty'),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-qty')
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: row.Quantity,
        decimals: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement)
      }));
    }
  }, {
    header: t('Time'),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-time')
      }, (0, _dateHelper.formatTime)(row.Timestamp));
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    columns: columns,
    rows: recentTrades,
    baseClass: baseClass,
    empty: t('No recent trades'),
    fetching: fetching
  });
};
RecentTradesComponent.propTypes = {
  selectedInstrument: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = RecentTradesComponent;